<template lang="html">
  <div class="loading">
    <i class="fa fa-circle-o-notch"></i><br><br>
    Votre devis est en cours de préparation...
  </div>
</template>

<script>
export default {
  data () {
    return {
      pdfLink: this.$store.state.pdfLink
    }
  },
  mounted () {
    setInterval(() => {
      if (this.$store.state.pdfLink !== this.pdfLink) {
        console.log(this.$store.state.pdfLink)
      }
    }, 250)
  }
}
</script>

<style lang="css" scoped>
@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  font-size: 30px;
  color: #000;
}
.loading i {
  animation: loading .5s linear infinite;
}
</style>



// WEBPACK FOOTER //
// pdf.vue?82c28e06